import React from 'react'
import styles from './attachmentSection.module.css'
import IMAGES from '../../../assets/images/images'
function FileUpload(props) {
    return (
         <div className={styles.container}>
            <div className={styles.logoiwrapper}>
                  <div ><img className={styles.logoicon} src={IMAGES.attach} /></div>
                  <div className={styles.text}>Drag and drop file here or <span className={styles.textlink}>Browse</span></div>
              </div>
              <div className={styles.text}>{props.displayMessage}</div>
          </div>
    )
}

export default FileUpload